export const initialClassState = {
  name: "",
  contact: "",
  imageUrl: null,
  members: [{ lastname: "", firstname: "", email: "" }],
};
